import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import Grow from '@mui/material/Grow';
import Popper from '@mui/material/Popper';

const LookSideBarEditButtonPopper = (props) => {

  const {placement, anchorRef, showPoints} = props;

  if (!anchorRef) {
    return null
  }

  return (
    <Popper open={showPoints}
            className={"look-step look-step--no-events look-step--" + placement}
            anchorEl={anchorRef.current}
            placement={placement}
            transition
            disablePortal>
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: placement === "right" ? "right center" : "left center" }}
        >
          <div className="look-step__content">
            <span className={"look-step__content-text look-step__content-text--" + placement}>
                <FormattedMessage id="sidebar.startCustomizing"/>
              </span>
          </div>
        </Grow>
      )}
    </Popper>
  )
};

LookSideBarEditButtonPopper.propTypes = {
  anchorRef: PropTypes.object.isRequired,
  placement: PropTypes.string
}

LookSideBarEditButtonPopper.defaultProps = {
  placement: "right"
}

export default LookSideBarEditButtonPopper
